export const MIN_DELAY_MINUTES = 15;
export const MAX_DELAY_HOURS = 20;
export const MAX_DELAY_MINUTES = MAX_DELAY_HOURS * 60;

export function cumulativeDelayMinutes(steps = []) {
  return steps.reduce((sum, step) => sum + Number(step.delayMinutes || 0), 0);
}

const SOCIAL_MESSAGING_WINDOW_HOURS = 20;

export function exceedsSocialWindow(steps = []) {
  return cumulativeDelayMinutes(steps) > SOCIAL_MESSAGING_WINDOW_HOURS * 60;
}

export function clampDelayMinutes(minutes) {
  return Math.min(
    MAX_DELAY_MINUTES,
    Math.max(MIN_DELAY_MINUTES, Number(minutes) || MIN_DELAY_MINUTES)
  );
}

export function inferDelayUnit(delayMinutes) {
  const minutes = Number(delayMinutes) || MIN_DELAY_MINUTES;
  if (minutes >= 60 && minutes % 60 === 0) {
    return "hours";
  }
  return "minutes";
}

export function delayDisplayValue(delayMinutes, unit) {
  const minutes = Number(delayMinutes) || MIN_DELAY_MINUTES;
  if (unit === "hours") {
    return Math.round(minutes / 60);
  }
  return minutes;
}

export function toDelayMinutes(value, unit) {
  const num = Number(value);
  if (unit === "hours") {
    const hours = Math.max(1, Math.min(MAX_DELAY_HOURS, Math.round(num) || 1));
    return clampDelayMinutes(hours * 60);
  }
  return clampDelayMinutes(num || MIN_DELAY_MINUTES);
}

export function delayInputMin(unit) {
  return unit === "hours" ? 1 : MIN_DELAY_MINUTES;
}

export function delayInputMax(unit) {
  return unit === "hours" ? MAX_DELAY_HOURS : MAX_DELAY_MINUTES;
}
